import { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost' | 'danger';
  loading?: boolean;
  children: ReactNode;
  fullWidth?: boolean;
}

export function Button({ variant = 'primary', loading, children, fullWidth, className, disabled, ...rest }: ButtonProps) {
  const base = 'flex items-center justify-center font-semibold rounded-2xl py-4 px-6 text-base transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'bg-primary text-white shadow-pink',
    outline: 'border border-white/20 text-white bg-transparent hover:bg-white/5',
    ghost: 'text-white/70 bg-transparent hover:bg-white/5',
    danger: 'bg-danger text-white',
  };

  return (
    <button
      className={clsx(base, variants[variant], fullWidth && 'w-full', className)}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <span className="w-5 h-5 rounded-full border-2 border-white border-t-transparent spinner inline-block" />
      ) : children}
    </button>
  );
}
